var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0812 11.6272C0.8252 11.6272 0.567866 11.5299 0.3732 11.3326C-0.0161335 10.9406 -0.0148002 10.3086 0.375867 9.91925L4.31187 5.99925L0.375867 2.08058C-0.0148002 1.69125 -0.0161335 1.05792 0.3732 0.665915C0.762533 0.272582 1.39453 0.275249 1.78653 0.663249L6.43453 5.29125C6.62253 5.47925 6.72787 5.73391 6.72787 5.99925C6.72787 6.26591 6.62253 6.52058 6.43453 6.70858L1.78653 11.3352C1.59187 11.5299 1.33587 11.6272 1.0812 11.6272Z",
    fill: "#F79C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRight);
export default __webpack_public_path__ + "static/media/icon-right.f6fd39b619efc9261a61acd4c4998339.svg";
export { ForwardRef as ReactComponent };